module.exports = "x-chartist{display:block;width:100%;height:100%;margin:0;padding:0}\n"